if (!customElements.get('product-grid-cta')) {
  class ProductGridCTA extends ObservedElement {
    constructor() {
      super();
      this.content = this.querySelector('[data-content]');

      this.addResizeObserver(this, this.scaleText, { debounced: false });
    }

    defaults() {
      return {
        minFontSize: 12,
        fontSizeStep: 1,
        fontSizeUnit: 'px',
      };
    }

    parsedCallback() {
      super.parsedCallback();

      this.scaleText();
    }

    hasOverflow() {
      return this.scrollHeight > this.clientHeight;
    }

    scaleText() {
      this.content.style.fontSize = '';
      let fontSize = parseInt(getComputedStyle(this.content).fontSize, 10);
      let overflow = this.hasOverflow();

      while (overflow && fontSize >= this.options.minFontSize) {
        fontSize -= this.options.fontSizeStep;
        this.content.style.fontSize = `${fontSize}${this.options.fontSizeUnit}`;
        overflow = this.hasOverflow();
      }
    }
  }

  customElements.define('product-grid-cta', ProductGridCTA);
}
